import React from 'react';
import { SectionNav } from './components/SectionNav';
import { CoverSection } from './components/CoverSection';
import { TypographySection } from './components/TypographySection';
import { ColorSection } from './components/ColorSection';
import { GraphicStyleSection } from './components/GraphicStyleSection';
import { IconographySection } from './components/IconographySection';
import { MessagingSection } from './components/MessagingSection';
import { ApplicationSection } from './components/ApplicationSection';
import { ContentTemplatesSection } from './components/ContentTemplatesSection';
import { OperationsDocumentsSection } from './components/OperationsDocumentsSection';
import { WebsiteRedesignSection } from './components/WebsiteRedesignSection';
import { PostersSection } from './components/PostersSection';
export function App() {
  return <div className="relative" data-id="element-0">
      <div className="fixed top-8 right-8 z-50 flex items-center gap-4" data-id="element-1">
        <div className="font-mono text-xs text-[var(--text-muted)]" data-id="element-2">
          v2026.1
        </div>
        <button className="px-4 py-2 bg-[var(--accent-blue)] text-white rounded-full text-sm font-medium hover:bg-opacity-90 transition-all" data-id="element-3">
          Export
        </button>
      </div>

      <SectionNav data-id="element-4" />

      <main className="relative" data-id="element-5">
        <CoverSection data-id="element-6" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-7" />
        <TypographySection data-id="element-8" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-9" />
        <ColorSection data-id="element-10" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-11" />
        <GraphicStyleSection data-id="element-12" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-13" />
        <IconographySection data-id="element-14" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-15" />
        <MessagingSection data-id="element-16" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-17" />
        <ApplicationSection data-id="element-18" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-19" />
        <ContentTemplatesSection data-id="element-20" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-21" />
        <OperationsDocumentsSection data-id="element-22" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-23" />
        <WebsiteRedesignSection data-id="element-24" />
        <div className="h-px bg-[var(--divider)] max-w-7xl mx-auto" data-id="element-25" />
        <PostersSection data-id="element-26" />
      </main>
    </div>;
}